import ContentLoader from 'react-content-loader';
import type { VoidFunctionComponent } from 'react';

import FluidLeftLayout from '../../../layouts/FluidLeftLayout';

import styles from '../IssueDetails.module.less';

/**
 * IssueDetailsFullPageLoading is the loading animation for
 * the entire issue details page.
 */
const IssueDetailsFullPageLoading: VoidFunctionComponent = () => (
  <div className={styles.body}>
    <ContentLoader width="100%" height="265px">
      {/* Header section... */}
      <rect x="0" y="0" rx="3" ry="3" width="15%" height="27" />
      <rect x="0" y="33" rx="3" ry="3" width="35%" height="28" />
      <rect x="0" y="67" rx="3" ry="3" width="28%" height="22" />
      {/* Status */}
      <rect x="0" y="102" rx="3" ry="3" width="20%" height="22" />
      {/* Action buttons */}
      <rect x="0" y="145" rx="3" ry="3" width="85" height="30" />
      <rect x="95" y="145" rx="3" ry="3" width="85" height="30" />
      {/* Tabs */}
      <rect x="0" y="210" rx="3" ry="3" width="8%" height="32" />
      <rect x="9%" y="210" rx="3" ry="3" width="8%" height="32" />
      <rect x="18%" y="210" rx="3" ry="3" width="8%" height="32" />
      <rect x="0" y="242" rx="0" ry="0" width="100%" height="2" />
    </ContentLoader>
    <FluidLeftLayout>
      <FluidLeftLayout.Left>
        <ContentLoader width="100%" height="510px">
          <rect x="0" y="0" rx="15" ry="15" width="100%" height="150" />
          <rect x="0" y="170" rx="15" ry="15" width="100%" height="150" />
          <rect x="0" y="340" rx="15" ry="15" width="100%" height="150" />
        </ContentLoader>
      </FluidLeftLayout.Left>
      <FluidLeftLayout.Right>
        <ContentLoader width="100%" height="510px">
          <rect x="0" y="0" rx="15" ry="15" width="100%" height="180" />
          <rect x="0" y="200" rx="15" ry="15" width="100%" height="180" />
        </ContentLoader>
      </FluidLeftLayout.Right>
    </FluidLeftLayout>
  </div>
);

export default IssueDetailsFullPageLoading;
